export const hslById = (number: number) => {
  const hue = number * 88.508; // use golden angle approximation
  return `hsl(${hue},50%,75%)`;
};
